// Quando estiver hospedado em app.hydrodataeng.com.br, usa o domínio custom
// da API. Em dev (localhost) ou cloudfront default, usa o gateway URL direto.
const _host = typeof window !== 'undefined' ? window.location.hostname : '';
const _useCustom = _host.endsWith('hydrodataeng.com.br');
export const API_URL = _useCustom
  ? 'https://api.hydrodataeng.com.br'
  : 'https://31h8c00wj8.execute-api.us-east-1.amazonaws.com/prod';